import { createClient } from '@supabase/supabase-js';

const readRuntimeEnv = (key: 'SUPABASE_URL' | 'SUPABASE_ANON_KEY'): string | undefined => {
  if (typeof window === 'undefined') return undefined;
  const value = window.ENV?.[key];
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

// Supabase configuration
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || readRuntimeEnv('SUPABASE_URL');
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || readRuntimeEnv('SUPABASE_ANON_KEY');

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// Create a single Supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
